function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "nc-icon-wrapper",
  fill: "#260c69"
}, /*#__PURE__*/React.createElement("g", {
  className: "nc-loop_dots-05-32"
}, /*#__PURE__*/React.createElement("circle", {
  "data-color": "color-2",
  cx: 16,
  cy: 8,
  r: 3,
  transform: "translate(0 4.108150000125169)"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#260c69",
  cx: 4,
  cy: 8,
  r: 3,
  transform: "translate(0 6.108150000125169)"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#260c69",
  cx: 28,
  cy: 8,
  r: 3,
  transform: "translate(0 2.1081500001251694)"
})), /*#__PURE__*/React.createElement("script", null, "!function(){function t(t){this.element=t,this.dots=[this.element.getElementsByTagName(\"circle\")[1],this.element.getElementsByTagName(\"circle\")[0],this.element.getElementsByTagName(\"circle\")[2]],this.animationId,this.start=null,this.init()}if(!window.requestAnimationFrame){var i=null;window.requestAnimationFrame=function(t,n){var e=(new Date).getTime();i||(i=e);var a=Math.max(0,16-(e-i)),o=window.setTimeout(function(){t(e+a)},a);return i=e+a,o}}t.prototype.init=function(){var t=this;this.animationId=window.requestAnimationFrame(t.triggerAnimation.bind(t))},t.prototype.reset=function(){var t=this;window.cancelAnimationFrame(t.animationId)},t.prototype.triggerAnimation=function(t){var i=this;this.start||(this.start=t);var n=t-this.start,e=Math.min(n/40,23);930>n||(this.start=this.start+930);for(var a=[],o=0;3>o;o++){a[o]=Math.max(e-2*o,0);if(a[o]>8)(a[o]=16-a[o]);a[o]=Math.max(a[o],0),this.dots[o].setAttribute(\"transform\",\"translate(0 \"+a[o]+\")\");}if(document.documentElement.contains(this.element))window.requestAnimationFrame(i.triggerAnimation.bind(i))};var n=document.getElementsByClassName(\"nc-loop_dots-05-32\"),e=[];if(n)for(var a=0;n.length>a;a++)!function(i){e.push(new t(n[i]))}(a);document.addEventListener(\"visibilitychange\",function(){\"hidden\"==document.visibilityState?e.forEach(function(t){t.reset()}):e.forEach(function(t){t.init()})})}();"));

var SvgButtonLoader = function SvgButtonLoader(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 20",
    width: 32,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonLoader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/button-loader.21471a48.svg";
export { ForwardRef as ReactComponent };